module.exports = __webpack_public_path__ + "static/media/favicon.b5f31a05.ico";